import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import _ from 'lodash';

import { Text, Heading } from 'grommet';

import Markup from 'app/api/markup';
import BookElement from 'app/api/bookElement';
import SectionBreak from 'app/components/BookElements/SectionBreak';
import TableOfContentsEntry from 'app/components/BookElements/TableOfContentsEntry';
import StyledParagraph from 'app/components/Paragraph';

function extractEntries(entries) {
  const { details, ...extracted } = entries;
  return extracted;
}

function Entry({ entries, section }) {
  const title = _.chain(section)
    .lowerCase()
    .startCase()
    .value();
  return (
    <React.Fragment>
      <Text as="h3" size="large" weight="bold">
        {title}
      </Text>
      {_.map(entries, entry => (
        <StyledParagraph key={entry} size="small">
          {Markup.parse(entry)}
        </StyledParagraph>
      ))}
    </React.Fragment>
  );
}

class References extends React.Component {
  render() {
    const { path, content } = this.props;
    if (BookElement.isNotSelected(path)) return null;
    return (
      <React.Fragment>
        <TableOfContentsEntry path={path}>
          <Heading responsive textAlign="center">
            References
          </Heading>
        </TableOfContentsEntry>
        {content.details && (
          <StyledParagraph size="small">{content.details}</StyledParagraph>
        )}
        {_.map(extractEntries(content), (entries, section) => (
          <Entry key={section} entries={entries} section={section} />
        ))}
        <SectionBreak />
      </React.Fragment>
    );
  }
}

References.propTypes = {
  /**
   * content path
   */
  path: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  /**
   * references entries
   */
  content: PropTypes.object,
};
References.defaultProps = {
  content: {},
};

const Component = inject('AppState')(observer(References));
Component.displayName = 'References';
export const ReferencesComponent = References;
export default Component;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/References.js